import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getHeaderSelectorsState } from '../header/store/header.selectors';

@Component({
  selector: 'app-ecosystem',
  templateUrl: './ecosystem.component.html',
  styleUrls: ['./ecosystem.component.scss']
})
export class EcosystemComponent implements OnInit {
  @Input() haveLateralName: boolean = false;
  
  check$: Observable<any>;
  storeData: any
  isEdPartnersOrigin = false;

  constructor( private store: Store) { }
  ngOnInit(): void {
    this.isEdPartnersOrigin = this.getCookie('from') === 'ed-partners' || this.getCookie('from') === 'ed-parterns';
    this.getStates()
  }

  getStates() {
    this.check$ = this.store.select(getHeaderSelectorsState);
    this.check$.subscribe((value) => {
      this.storeData = {
        ...(this.storeData = value)
      }
    });
  }

  private getCookie(name: string): string {
    const cookie = document.cookie
      .split('; ')
      .find((item) => item.startsWith(`${name}=`));

    return cookie ? decodeURIComponent(cookie.split('=')[1]) : '';
  }
}
